export const SOFT_LIMIT_IMG = "/images/homepage/empty-query-bar.svg";
